import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Grid, TextField, FormControl, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DrangAndDrop from './DragAndDrop';

const useStyles = makeStyles(() => ({
  input: {
    width: '100%'
  },
  disabled: {
    width: '100%',
    color: 'rgba(0, 0, 0, 0.38)'
  },
  form: {
    marginBottom: 0
  },
  formControl: {
    width: '100%',
    marginTop: 16
  },
  button: {
    marginTop: 16
  }
}));

const UploadForm = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    handleSubmit,
    handleCancel,
    setContent,
    accept,
    nameLabel = t('docUpload:docName'),
    nameValue,
    descriptionLabel = t('docUpload:docDescription'),
    descriptionValue,
    actionButtonLabel = t('docUpload:createNewDoc'),
    newDocument,
    disabledBtnSubmit,
    multiple,
    currentFiles
  } = props;
  const disabled = Boolean(disabledBtnSubmit);
  const [name, setName] = useState(nameValue || '');
  const [description, setDescription] = useState(descriptionValue || '');

  const onChangeName = (e) => {
    setName(e.target.value);
  };

  const onChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  const onUploadedFiles = (e) => {
    if (!name) {
      setName(e[0].name.replace(/\.[^/.]+$/, ''));
    }
    setContent(e);
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <Grid container>
        <DrangAndDrop
          setContent={onUploadedFiles}
          accept={accept}
          multiple={multiple}
          currentFiles={currentFiles}
        />
        <TextField
          disabled={!newDocument}
          id='name'
          label={nameLabel}
          margin='normal'
          value={name}
          onChange={onChangeName}
          className={classes.input}
          InputProps={{
            classes: {
              disabled: !newDocument && classes.disabled
            }
          }}
          InputLabelProps={{ style: { color: !newDocument && 'rgba(0, 0, 0, 0.38)' } }}
          required
        />
        <TextField
          disabled={!newDocument}
          id='description'
          label={descriptionLabel}
          margin='normal'
          value={description}
          onChange={onChangeDescription}
          className={classes.input}
          InputProps={{
            classes: {
              disabled: !newDocument && classes.disabled
            }
          }}
          InputLabelProps={{ style: { color: !newDocument && 'rgba(0, 0, 0, 0.38)' } }}
        />
        <FormControl className={classes.formControl}>
          <Button variant='outlined' color='primary' onClick={handleCancel}>
            {t('docUpload:cancel')}
          </Button>
          <Button disabled={disabled} variant='contained' color='primary' type='submit' className={classes.button}>
            {actionButtonLabel}
          </Button>
        </FormControl>
      </Grid>
    </form>
  );
};

UploadForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  newDocument: PropTypes.bool,
  multiple: PropTypes.bool,
  setContent: PropTypes.func.isRequired,
  accept: PropTypes.string,
  title: PropTypes.string.isRequired,
  nameLabel: PropTypes.string,
  nameValue: PropTypes.string,
  descriptionLabel: PropTypes.string,
  descriptionValue: PropTypes.string,
  actionButtonLabel: PropTypes.string,
  disabledBtnSubmit: PropTypes.bool
};

export default UploadForm;
